import { z } from "zod";
export const GetSpectroDataArgs = z.object({
    plantId: z.number(),
});
export const SpectroData = z.array(z.record(z.nullable(z.string())));
//# sourceMappingURL=spectro.js.map